const escolas_sem_turmas_criadas = {
  path: "/relatorio-de-apoio-gerencial-escolas-sem-turmas-criadas",
  redirect: "/relatorio-de-apoio-gerencial-escolas-sem-turmas-criadas",
  meta: {
    breadCrumb:
      "Gerenciamento de Matrícula - Apoio Gerencial de Planejamento da Turma",
  },
  children: [
    {
      path: "/relatorio-de-apoio-gerencial-escolas-sem-turmas-criadas",
      name: "/relatorio-de-apoio-gerencial-escolas-sem-turmas-criadas",
      meta: {
        allowedPermissions: ["estrutura_turma_escola_sem_turma"],
      },
      component: () =>
        import(
          "@/views/RelatorioApoioGerencialEscolasSemTurmasCriadas/RelatorioApoioGerencialEscolasSemTurmasCriadas.vue"
        ),
    },
  ],
};

export { escolas_sem_turmas_criadas };
